import { objectToUrlParams } from 'utils/params';
import BaseResource from './BaseResource';
import MarketplaceProductResource from './MarketplaceProductResource';
import MarketplaceProductVariantResource from './MarketplaceProductVariantResource';

export default class MarketplaceProductsResource extends BaseResource {
  constructor() {
    super({ url: '/api/products' });
  }

  list({ size = 15, includes = '', search = '', offset = 0 } = {}) {
    const params = { size, includes, offset, search };
    const urlParams = objectToUrlParams(params);
    return super
      .get({ url: `${this.url}${urlParams}` })
      .then((response) => response)
      .catch((error) => error.response);
  }

  create(data) {
    return super
      .post(data)
      .then((response) => response)
      .catch((error) => error.response);
  }

  product(id) {
    return new MarketplaceProductResource(`${this.url}/${id}`);
  }

  variant(id) {
    return new MarketplaceProductVariantResource(`/api/variants/${id}`);
  }
}
